
export interface CBCLevel {
    code: 'EE' | 'ME' | 'AE' | 'BE';
    name: string;
    description: string;
    min: number;
    max: number;
    color: string;
}

export const CBC_LEVELS: CBCLevel[] = [
    {
        code: 'EE',
        name: 'Exceeding Expectations',
        description: 'The learner consistently and correctly demonstrates supervision.',
        min: 80,
        max: 100,
        color: 'text-green-700 font-bold'
    },
    {
        code: 'ME',
        name: 'Meeting Expectations',
        description: 'The learner correctly demonstrates the competency.',
        min: 65,
        max: 79,
        color: 'text-blue-700 font-bold'
    },
    {
        code: 'AE',
        name: 'Approaching Expectations',
        description: 'The learner inconsistently demonstrates the competency.',
        min: 50,
        max: 64,
        color: 'text-yellow-600 font-bold'
    },
    {
        code: 'BE',
        name: 'Below Expectations',
        description: 'The learner demonstrates the competency with major inaccuracies.',
        min: 0,
        max: 49,
        color: 'text-red-600 font-bold'
    }
];

export const getCBCLevel = (score: number, total: number): CBCLevel => {
    const percentage = total > 0 ? (score / total) * 100 : 0;
    return CBC_LEVELS.find(l => percentage >= l.min && percentage <= l.max) || CBC_LEVELS[3]; // Default to BE if out of range/error
};

export const CORE_COMPETENCIES = [
    "Communication and Collaboration",
    "Critical Thinking and Problem-Solving",
    "Creativity and Imagination",
    "Citizenship",
    "Digital Literacy",
    "Learning to Learn",
    "Self-Efficacy"
];

export const VALUES = [
    "Responsibility",
    "Respect",
    "Excellence",
    "Care and Compassion",
    "Understanding and Tolerance",
    "Honesty and Integrity",
    "Unity and Patriotism",
    "Peace"
];
